// How far the water skirt (TerrainWater.makeHexPlane) hangs below the surface: deeper than the biggest step
// between water depth classes (coast -0.08 vs deep -0.53). Its own module so the shader chunks and the geometry
// agree without importing each other.
export const WATER_SKIRT_DEPTH = 0.8;
